<template>
  <div class="hamburger" @click="onClick">
     <!-- <img 
     src="../../assets/hamburger.svg"
      /> -->
    <!-- <div></div>
    <div></div>
    <div></div> -->
  </div>
</template>

<script>
export default {
  props: {
    onClick: {
      type: Function
    }
  }
};
</script>

<style scoped>
.hamburger {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
  flex-wrap: nowrap;
  width: 32px;
  height: 32px;
  position: absolute;
  right: 20px;
  background-image: url("../../assets/hamburger.svg");
}
/* when hamburger is dot. */
/* .hamburger div {
  display: inline-block;
  border-radius: 6px;
  width: 7px;
  height: 7px;
  /* margin-right: 8px; */
  /* background-color: white;
} */ 
@media (max-width: 1024px) {
  .hamburger {
    width: 32px;
    position: static;
    right: auto;
  }
  .hamburger div {
    width: 4px;
    height: 4px;
  }
}
</style>
